import React from 'react';

export const states = [
    {
        value: "default",
        name: "Select"
    },
    {
        value: "AL",
        name: "Alabama"
    },
    {
        value: "AK",
        name: "Alaska"
    },
    {
        value: "AS",
        name: "American Samoa"
    },
    {
        value: "AZ",
        name: "Arizona"
    },
    {
        value: "AR",
        name: "Arkansas"
    },
    {
        value: "CA",
        name: "California"
    },
    {
        value: "CO",
        name: "Colorado"
    },
    {
        value: "CT",
        name: "Connecticut"
    },
    {
        value: "DE",
        name: "Delaware"
    },
    {
        value: "DC",
        name: "District of Columbia"
    },
    {
        value: "FM",
        name: "Federated States of Micronesia"
    },
    {
        value: "FL",
        name: "Florida"
    },
    {
        value: "GA",
        name: "Georgia"
    },
    {
        value: "GU",
        name: "Guam"
    },
    {
        value: "HI",
        name: "Hawaii"
    },
    {
        value: "ID",
        name: "Idaho"
    },
    {
        value: "IL",
        name: "Illinois"
    },
    {
        value: "IN",
        name: "Indiana"
    },
    {
        value: "IA",
        name: "Iowa"
    },
    {
        value: "KS",
        name: "Kansas"
    },
    {
        value: "KY",
        name: "Kentucky"
    },
    {
        value: "LA",
        name: "Louisiana"
    },
    {
        value: "ME",
        name: "Maine"
    },
    {
        value: "MH",
        name: "Marshall Islands"
    },
    {
        value: "MD",
        name: "Maryland"
    },
    {
        value: "MA",
        name: "Massachusetts"
    },
    {
        value: "MI",
        name: "Michigan"
    },
    {
        value: "MN",
        name: "Minnesota"
    },
    {
        value: "MS",
        name: "Mississippi"
    },
    {
        value: "MO",
        name: "Missouri"
    },
    {
        value: "MT",
        name: "Montana"
    },
    {
        value: "NE",
        name: "Nebraska"
    },
    {
        value: "NV",
        name: "Nevada"
    },
    {
        value: "NH",
        name: "New Hampshire"
    },
    {
        value: "NJ",
        name: "New Jersey"
    },
    {
        value: "NM",
        name: "New Mexico"
    },
    {
        value: "NY",
        name: "New York"
    },
    {
        value: "NC",
        name: "North Carolina"
    },
    {
        value: "ND",
        name: "North Dakota"
    },
    {
        value: "MP",
        name: "Northern Mariana Islands"
    },
    {
        value: "OH",
        name: "Ohio"
    },
    {
        value: "OK",
        name: "Oklahoma"
    },
    {
        value: "OR",
        name: "Oregon"
    },
    {
        value: "PW",
        name: "Palau"
    },
    {
        value: "PA",
        name: "Pennsylvania"
    },
    {
        value: "PR",
        name: "Puerto Rico"
    },
    {
        value: "RI",
        name: "Rhode Island"
    },
    {
        value: "SC",
        name: "South Carolina"
    },
    {
        value: "SD",
        name: "South Dakota"
    },
    {
        value: "TN",
        name: "Tennessee"
    },
    {
        value: "TX",
        name: "Texas"
    },
    {
        value: "UT",
        name: "Utah"
    },
    {
        value: "VT",
        name: "Vermont"
    },
    {
        value: "VI",
        name: "Virgin Islands"
    },
    {
        value: "VA",
        name: "Virginia"
    },
    {
        value: "WA",
        name: "Washington"
    },
    {
        value: "WV",
        name: "West Virginia"
    },
    {
        value: "WI",
        name: "Wisconsin"
    },
    {
        value: "WY",
        name: "Wyoming"
    }
];

export const employmentStatus = [
    {
        value: 'default',
        name: 'Select One'
    },
    {
        value: 'Student',
        name: 'Student'
    },
    {
        value: 'Employed',
        name: 'Employed'
    },
    {
        value: 'SelfEmployed',
        name: 'Self-Employed'
    },
    {
        value: 'NotEmployed',
        name: 'Not Employed or Retired'
    },
];

export const guarantorRelationships = [
    {value: 'default', name: 'Select One'},
    {value: 'parent', name: 'Parent'},
    {value: 'relative', name: 'Relative'},
    {value: 'other', name: 'Other'},
];

export const educationLevels = [
    {value: 'default', name: 'Select One'},
    {value: 'no_highschool', name: 'Did Not Complete High School'},
    {value: 'highschool', name: 'High School/GED'},
    {value: 'some_college', name: 'Some College (or currently enrolled)'},
    {value: 'associates_degree', name: 'Associates Degree'},
    {value: 'bachelors_degree', name: 'Bachelors Degree'},
    {value: 'masters_degree', name: 'Masters Degree'},
    {value: 'doctorate_degree', name: 'Doctoral Degree'},
];

export const months = {
    "January": 1,
    "February": 2,
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12
};

export const tuRenterTOS = (
    <div>
        <p>Welcome to TransUnion&reg; ShareAble&reg;, found at the web site, [www.hire.sharable.com], or through an
            integration platform (the "Site") - a product of TransUnion Rental Screening Solutions ("TURSS"). This Terms of Use Agreement ("Agreement") contains the
            terms and conditions upon which you ("you," or the "Member") may access ShareAble or any products or services offered through the Site. You agree to be
            legally bound by these terms.</p>

        <p><strong>General Terms</strong></p>
        <p>TURSS provides access to ShareAble to allow you to authorize and agree to provide your credit and public record information (""Consumer Report Information" or "Credit Information") to third
            parties through this platform. From time to time TURSS and or the owner of this platform may revise these terms and conditions. Revisions will be effective
            when posted or as otherwise stated. Additional terms and conditions may apply to specifics of other products and services, or to the participation in future
            contests or surveys.</p>
        <p>After agreeing to the terms of this Agreement, you will be requested to authenticate your identity using information from public records and credit
            information related to the identifying information that you provide (e.g. Social Security Number, Date of Birth) ("Identifying Information") and
            acknowledge that upon successful completion of identity verification, your Consumer Report Information will be provided to third parties
            indicated on your request via this platform. You acknowledge and agree that TURSS and the platform provider is not responsible for any actions or decisions
            made by any third parties with whom you have agreed to share your Consumer Report Information.</p>
        <p>The images, text, screens, web pages, materials, data, content and other information ("Content") used and displayed through ShareAble and/or the Site are the
            property of TURSS or its licensors and are protected by copyright, trademark and other laws. In addition to its rights in individual elements of the Content
            within the Site, TURSS owns intellectual property rights in the selection, coordination, arrangement and enhancement of such Content. None of the Content
            may be copied, displayed, distributed, downloaded, licensed, modified, published, reposted, reproduced, reused, sold, transmitted, used to create a
            derivative work or otherwise used for public or commercial purposes without the express written permission of TURSS or the owner of the Content.</p>

        <p><strong>Disclaimer of Warranties and Liabilities</strong></p>
        <p>SHAREABLE AND THE SITE, INCLUDING ALL CONTENT, CREDIT INFORMATION, PRODUCTS AND SERVICES MADE AVAILABLE ON OR ACCESSED THROUGH THIS SITE, ARE PROVIDED TO YOU
            "AS IS". TO THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW, NEITHER TURSS NOR ITS AFFILIATES NOR ITS DATA PROVIDERS MAKE ANY REPRESENTATIONS OR
            WARRANTIES OF ANY KIND WHATSOEVER AS TO THE CONTENT, CREDIT INFORMATION, PRODUCTS OR SERVICES AVAILABLE ON OR ACCESSED THROUGH SHAREABLE AND THE SITE, THAT
            YOU OR A THIRD PARTY WILL HAVE CONTINUOUS, UNINTERRUPTED OR SECURE ACCESS TO SHAREABLE OR THE SITE, PRODUCTS OR SERVICES OR THAT SHAREABLE, THE SITE,
            PRODUCTS OR SERVICES WILL BE ERROR-FREE. IN ADDITION, TURSS AND ITS AFFILIATES AND ITS DATA PROVIDERS DISCLAIM ALL EXPRESS OR IMPLIED WARRANTIES, INCLUDING
            TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT AND INFORMATIONAL CONTENT. THEREFORE, YOU AGREE THAT YOUR ACCESS TO AND USE OF
            SHAREABLE, THE SITE, PRODUCTS, SERVICES AND CONTENT ARE AT YOUR OWN RISK. ADDITIONALLY, YOU AGREE THAT THE CREDIT INFORMATION THAT YOU AUTHORIZE TURSS TO
            SHARE WITH THIRD PARTIES IS NOT ERROR-FREE AND MAY INCLUDE INFORMATION THAT DOES NOT PERTAIN TO YOU AND TURSS AND ITS AFFILIATES AND ITS DATA PROVIDERS ARE
            NOT RESPONSIBLE OR LIABLE FOR ANY ACTION OR DECISION TAKEN BY A THIRD PARTY BASED ON THE CREDIT INFORMATION. BY USING OUR SITE, YOU ACKNOWLEDGE AND AGREE
            THAT NEITHER TURSS NOR ITS AFFILIATES NOR ITS DATA PROVIDERS HAVE ANY LIABILITY TO YOU (WHETHER BASED IN CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE) FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL OR SPECIAL DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH YOUR ACCESS TO OR USE OF SHAREABLE, THE SITE,
            CONTENT, PRODUCTS OR SERVICES (EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), INCLUDING LIABILITY ASSOCIATED WITH ANY VIRUSES WHICH MAY
            INFECT YOUR COMPUTER EQUIPMENT. YOU ACKNOWLEDGE AND AGREE THAT TURSS'S DATA PROVIDERS ARE A THIRD PARTY BENEFICIARY OF THE PROVISIONS OF THIS SECTION, WITH RIGHT OF ENFORCEMENT.</p>
        <p>TURSS reserves the right to publish or use any responses, questions or comments emailed to TURSS promotional or other purposes without any further
            permission, notice or payment of any kind to the sender. All such submissions are the property of TURSS.</p>

        <p><strong>Registration and Accurate Information</strong></p>
        <p>If you decide to register on the Site or use ShareAble, you may be required to register, provide personal information, and select a user name and password.
            You agree to provide accurate information in your registration and not to share your password with third parties. You agree not to impersonate another
            person or to select or use a user name or password of another person. You agree to notify TURSS promptly of any unauthorized use of your account and of any
            loss, theft or disclosure of your password. Failure to comply with these requirements shall constitute a breach of these terms and conditions and shall
            constitute grounds for immediate termination of your account and your right to use the Site.</p>

        <p><strong>Our Privacy Policy</strong></p>
        <p>By using the Site or purchasing products or services, you agree that we may use and share your personal information in accordance with the terms of our
            Privacy Statement. Our privacy statement can be reached at www.shareable.com.</p>

        <p><strong>Fair Credit Reporting Act</strong></p>
        <p>The Fair Credit Reporting Act allows you to obtain from each consumer reporting agency a disclosure of all the information in your consumer file at the time of
            the request. Full disclosure of information in your file at a consumer reporting agency must be obtained directly from such consumer reporting agency. The
            credit reports provided or requested through our Site are not intended to constitute the disclosure of information by a consumer reporting agency as required
            by the Fair Credit Reporting Act or similar laws.</p>
        <p>You are entitled to receive a free copy of your consumer report from a consumer reporting agency if:</p>
        <ul>
            <li>You have been denied or were otherwise notified of an adverse action related to credit, insurance, employment, or a government granted license or other
                government granted benefit within the past sixty (60) days based on information in a credit report provided by such agency.
            </li>
            <li>You have been denied house/apartment rental or were required to pay a higher deposit than usually required within the past sixty (60) days based on
                information in a consumer report provided by such agency.
            </li>
            <li>You certify in writing that you are a recipient of public welfare assistance.
            </li>
            <li>You certify in writing that you have reason to believe that your file at such credit reporting agency contains inaccurate information due to fraud.
            </li>
        </ul>
        <p>In addition, if you are a resident of Colorado, Maine, Maryland, Massachusetts, New Jersey, or Vermont, you may receive one free copy of your consumer
            report each year from the consumer reporting agencies. If you are a resident of Georgia, you may receive two free copies of your consumer report each year from the
            credit bureaus. Otherwise, a consumer reporting agency may impose a reasonable charge for providing you with a copy of your consumer report.</p>
        <p>The Fair Credit Reporting Act provides that you may dispute inaccurate or incomplete information in your consumer report. YOU ARE NOT REQUIRED TO PURCHASE
            YOUR CONSUMER REPORT FROM THE SITE OR SHAREABLE IN ORDER TO DISPUTE INACCURATE OR INCOMPLETE INFORMATION IN YOUR REPORT OR TO RECEIVE A COPY OF YOUR
            REPORT FROM EQUIFAX, EXPERIAN OR TRANSUNION, THE THREE NATIONAL CREDIT REPORTING AGENCIES, OR FROM ANY OTHER CREDIT REPORTING AGENCY.</p>

        <p><strong>Term and Termination; Modification</strong></p>
        <p>This Agreement will take effect at the time you click "I Accept," and shall terminate (a) when either party gives notice of its intention to terminate
            to the other party hereto, to TURSS via the toll-free number set forth on the web site, or (b) if TURSS discontinues providing ShareAble or access to the Site.</p>
        <p>TURSS may (i) change the terms of this Agreement or the feature of the Service, or (ii) change the Site, including eliminating or discontinuing any
            content or feature of the Site, restricting the hours of availability, or limiting the amount of use of the Site without notice. If you use ShareAble and/or
            the Site after TURSS has implemented such changes, you agree to be bound by all of the changes made to the Site or to this Agreement. You are expected to review
            the Site periodically to ensure familiarity with any posted notices of modification.</p>

        <p><strong>Policy Regarding Minors</strong></p>
        <p>We define minors as individuals under the age of 18. Our Web Site is not intended for the use of children and we do not intend to collect information about
            children through our Web Site. You must be at least 18 to access any products through this website.</p>

        <p><strong>Notices</strong></p>
        <p>You should send any notices or other communications regarding ShareAble or our Site to TransUnion Rental Screening Solutions, Attn.: Counsel for TURSS, 555 W. Adams Street, Chicago, IL 60661.</p>
        <p>Except as otherwise provided on this Site, we may send any notices to you to the most recent e-mail address you have provided to us or, if you have not provided an e-mail
            address, to any e-mail or postal address that we believe is your address. If you wish to update your registration information, please log in to your account
            and visit the 'Your Account' section from the main menu.</p>

        <p><strong>Applicable Law</strong></p>
        <p>The laws applicable to the interpretation of these terms and conditions shall be the laws of the State of Illinois, USA, and applicable federal law, without
            regard to any conflict of law provisions. TURSS can provide credit reports only on individuals who have established credit in the United States. Those who
            choose to access this Site from outside the United States do so on their own initiative and are responsible for compliance with local laws. You agree that
            any and all disputes arising under this Agreement or out of TURSS' provision of services to you, if submitted to a court of law, shall be submitted to the
            state and federal courts of Northern District of Illinois, USA.</p>

        <p><strong>Permission Statement</strong></p>
        <p>You understand that by clicking on the "I Accept" button immediately following this notice, you are providing written authorization to TransUnion Rental
            Screening Solutions to obtain information from your personal credit profile from TransUnion and public records sources. You authorize TransUnion Rental
            Screening Solutions to obtain such information and provide it to certain identified third parties who are requesting this
            information about you. Before you may use TransUnion ShareAble, we must obtain written authorization from you to give us permission to obtain your
            TransUnion credit history and public records report and share them with certain identified third parties.</p>
    </div>
);

export const tuLandlordTOS = (
    <div>
        <p>This is the service agreement to use ShareAble&reg; ("Service Agreement"). Your acknowledgement and agreement to these
            terms, as well as the Terms and Conditions of the internet site you are accessing ("Site"), are required to access and/or use
            TransUnion ShareAble. You agree to be legally bound by these terms. This Service Agreement is made and entered into
            as by and between TransUnion Rental Screening Solutions, Inc. ("TURSS") and you/your company ("Subscriber," "You" or
            "Property Owner"). In consideration of the promises and mutual covenants hereinafter set forth, TURSS and Subscriber
            hereto agree as follows:</p>

        <p>1. <b>Scope of Agreement</b>. This Agreement applies to any of those information services which Subscriber may desire
            to receive from TURSS and which TURSS offers to Subscriber via this Site. Such information services shall
            herein be collectively referred to as "Services" and all information derived therefrom shall be collectively referred
            to as "Services Information." Subscriber enters in this Agreement on behalf of itself and its affiliates under
            common ownership and control, all of which are referred to collectively as Subscriber.</p>

        <p>2. <b>Subscriber's business</b>. Subscriber certifies that it is utilizing the Services solely for assisting with making a
            residential or storage leasing decision.</p>

        <p>3. <b>Consumer Reporting Services</b></p>

        <p>3.1 <u>Consumer Report Information</u>. TURSS makes certain consumer report information services from consumer
            reporting databases, including but not limited to consumer credit reports, and criminal record reports ("Consumer
            Report Information"), available to its customers who have a permissible purpose for receiving such information in
            accordance with the Fair Credit Reporting Act (15 U.S.C. §1681 et seq.) including, without limitation, all
            amendments thereto ("FCRA"). For the purposes of this Agreement, the term "adverse action" shall have the
            same meaning as that term is defined in the FCRA.</p>

        <p>3.2 <u>FCRA Penalties</u>. THE FCRA PROVIDES THAT ANY PERSON WHO KNOWINGLY AND WILLFULLY OBTAINS
            INFORMATION ON A CONSUMER FROM A CONSUMER REPORTING AGENCY UNDER FALSE
            PRETENSES SHALL BE FINED UNDER TITLE 18, OR IMPRISONED NOT MORE THAN TWO YEARS, OR BOTH.</p>

        <p>3.3 <u>Subscriber Certifications</u>. Subscriber certifies that it shall request Consumer Report Information pursuant to the
            written authorization of the consumer who is the subject of the Consumer Report Information. Subscriber certifies
            that each such written authorization will expressly authorize Subscriber to obtain the Consumer Report
            Information, and will contain at a minimum the subject's name, address, social security number (where available)
            and signature. Subscriber shall use such Consumer Report Information solely for Subscriber's exclusive one-time
            use and pursuant to the consumer's written authorization and to use such information solely for assisting with
            making a residential or storage lease decision, and for no other purpose, subject however, to the additional
            restrictions set forth herein. Moreover, if requested by TURSS, Subscriber agrees to, and shall, individually certify
            the permissible purpose for each Consumer Report Information it requests. Such individual certification shall be
            made by Subscriber pursuant to instructions provided from time to time to Subscriber by TURSS. Nothing in this
            certification, or elsewhere in this Agreement, is intended to allow Subscriber to purchase Consumer Report
            Information for the purpose of selling or giving the report, or information contained in or derived from it, to the
            subject of the report, or to any other third party, and Subscriber expressly agrees to refrain from such conduct
            except where required by law.</p>

        <p>3.4 <u>All rental decisions to be made by Subscriber</u>. Subscriber acknowledges and agrees that all decisions of whether
            or not to rent property to a particular Applicant or Tenant, as well as the length of and terms of any such rental,
            will be made by Subscriber. TURSS shall have no liability to Subscriber or to any Applicant, Tenant, or other
            person or entity for any rental, or the failure to rent, to any Applicant or Tenant or the terms of any such rental,
            regardless of whether or not Subscriber's decision was based on Consumer Report Information, public records, or
            other information provided to Subscriber by TURSS.</p>

        <p>3.5 <u>Compliance with Laws</u>. Subscriber shall be responsible for compliance with all applicable federal (including, but
            not limited to the FCRA) and state laws, rules, regulations and judicial actions, as now or as may become
            effective, to which it is subject.</p>

        <p>3.6 Subscriber certifies it shall comply with all requirements related to the public record information ("Public Record
            Information") and other applicable data use restrictions ("Data Source Requirements") described at
            http://rentalscreening.transunion.com/sites/default/files/RS-Data-Source-Requirements-Agreement.pdf, which
            may be altered by TURSS from time to time, and certifies that any distribution of the Public Record Information or
            a Consumer Report shall comply with and contain the state-specific requirements described at
            http://rentalscreening.transunion.com/sites/default/files/RS-Data-Source-Requirements-Agreement.pdf which may
            be altered by TURSS from time to time.</p>

        <p>4. <b>Ancillary Services</b></p>

        <p>4.1 <u>Fraud Prevention Services</u>. TURSS offers several fraud prevention services that evaluate inquiry input elements
            against other input elements and/or against proprietary databases, to identify potential discrepancies and/or
            inaccuracies. Fraud prevention service messages may be delivered with Consumer Report Information as a
            convenience, but are not part of a consumer's file nor are they intended to be consumer reports. In the event
            Subscriber obtains any fraud prevention services from TURSS in conjunction with Consumer Report Information
            or as a standalone service, Subscriber shall not use the fraud prevention services, in whole or in part, as a factor
            in establishing an individual's creditworthiness or eligibility for credit or insurance, or employment, nor for any
            other purposes under the FCRA. Moreover, Subscriber shall not take any adverse action, which is based in whole
            or in part on the fraud prevention services, against any consumer. As a result of information obtained from the
            fraud prevention services, it is understood that Subscriber may choose to obtain additional information from one
            or more additional independent sources. Any action or decision as to any individual which is taken or made by
            Subscriber based solely on such additional information obtained from such additional independent source(s) shall
            not be deemed prohibited by this paragraph.</p>

        <p>4.2 <u>Scores</u>. Subscriber may request, in writing, that TURSS provide Subscriber certain credit scores, which shall
            include ResidentScore, collectively referred to herein as "Score(s)," for Subscriber's exclusive use. TURSS
            agrees to perform such processing as reasonably practicable. Subscriber shall use Scores only in accordance
            with its permissible purpose under the FCRA certified at the time of its request for such Scores; and, may store
            Scores solely for Subscriber's own use in furtherance of Subscriber's original purpose for obtaining the Scores.
            Subscriber shall not use the Scores for model development or model calibration and shall not reverse engineer
            the Scores.</p>

            <p>4.2.1 <u>Adverse Action Factors</u>. Subscriber recognizes that factors other than the Scores may be considered
                in making a decision as to a consumer. Such other factors include, but are not limited to, the credit
                report, the individual account history, application information, and economic factors. TURSS may
                provide score reason codes to Subscriber, which are designed to indicate the principal factors that
                contributed to the Score, and may be disclosed to consumers as the reasons for taking adverse
                action, as required by the Equal Credit Opportunity Act ("ECOA") and its implementing Regulation
                ("Reg. B"). The Score itself, when accompanied by the corresponding reason codes, may also be
                disclosed to the consumer who is the subject of the Score. However, the Score itself may not be
                used as the reason for adverse action under Reg. B.</p>

            <p>4.2.2 <u>Confidentiality of Scores</u>. Scores are proprietary to TURSS and without appropriate prior written
                consent, Scores may not be sold, licensed, copied, reused, disclosed, reproduced, revealed or made
                accessible, in whole or in part, to any Person except: (a) as expressly permitted herein; (b) to those
                employees of Subscriber with a need to know and in the course of their employment; (c) to those third
                party processing agents of Subscriber who have executed an agreement that limits the use of the
                Scores by the third party only to the use permitted to Subscriber and contains the prohibitions set
                forth herein regarding model development, model calibration and reverse engineering; (d) when
                accompanied by the corresponding reason codes, to the consumer who is the subject of the Score;
                or (e) as required by law. Subscriber shall not, nor permit any third party to, publicly disseminate any
                results of the validations or other reports derived from the Scores without prior written consent.</p>

            <p>4.2.3 <u>Score Performance</u>. Certain Scores are implemented with standard minimum exclusion criteria.
                TURSS shall not be liable to Subscriber for any claim, injury or damage suffered directly or indirectly
                by Subscriber as a result of any Subscriber requested changes to the exclusion criteria which result in
                normally excluded records being scored by such Scores. TURSS warrants that the scoring
                algorithms used in the computation of the scoring services, provided under this Agreement,
                ("Models") are empirically derived from credit data and are a demonstrably and statistically sound
                method of rank-ordering candidate records with respect to the purpose of the Scores when applied to
                the population for which they were developed, and that no scoring algorithm used by a Score uses a
                "prohibited basis" as that term is defined in ECOA and Reg. B promulgated thereunder. Scores may
                appear on a credit report for convenience only, but is not a part of the credit report nor does it add to
                the information in the report on which it is based.</p>

            <p>4.2.4 <u>Scores without score factors / adverse action codes</u>. Scores without score factors / adverse action
                codes may be made available to Subscriber in conjunction with Subscriber's request for Consumer
                Report Information. Subscriber hereby represents and warrants that when Subscriber requests Scores
                without score factors / adverse action codes, Subscriber shall not use such Scores, nor any information
                derived therefrom to take any adverse action as to any individual consumer.</p>

            <p>4.2.5 <u>Third Party Scores and Other Third Party Services</u>. TURSS has the capability to offer scores derived
                from models built jointly with third parties, and other services provided by third parties, which are
                subject to additional warranties offered or terms imposed by such third parties. If desired by
                Subscriber, such third party scores and services shall be made available pursuant to separate
                agreement, which shall be appended as a schedule to this Agreement.</p>

        <p>4.3 <u>Subscriber Forms</u>. TURSS may offer the ability to electronically maintain and make available to Subscriber, at
            Subscriber's request and direction, Subscriber's forms including, but not limited to, lease forms, lease addenda,
            and consumer correspondence. Subscriber acknowledges and agrees that it is Subscriber's obligation to ensure
            the accuracy and completeness of the forms and to ensure its compliance with all applicable laws related to the
            use of such forms. TURSS makes no representations or warranties as to the content or use of such forms.</p>

        <p>4.4 <u>Subscriber Access</u>. Subscriber agrees that TURSS may store data provided to Subscriber hereunder on behalf of
            Subscriber to be used by Subscriber solely for audit or compliance purposes and for no other purpose. All data
            stored on behalf of Subscriber by TURSS shall be owned by Subscriber and may not be modified in any manner.</p>

        <p>5. <b>Additional Terms and Conditions</b></p>

        <p>5.1 <u>Confidentiality</u>. Subscriber shall hold all Services Information in confidence and shall not disclose the Services to
            any third party, except as required by law (i.e., an order of a court or data request from an administrative or
            governmental agency with competent jurisdiction) to be disclosed; provided however, that Subscriber shall
            provide TURSS ten (10) days prior written notice before the disclosure of such information pursuant to this
            Paragraph 3.9. However, this restriction shall not prohibit Subscriber from disclosing to the subject of the
            Consumer Report Information, who is the subject of an adverse action, the content of the Consumer Report
            Information as it relates to any such adverse action.</p>

        <p>5.2 <u>Safeguards</u>. Each party shall implement, and shall take measures to maintain, reasonable and appropriate
            administrative, technical, and physical security safeguards ("Safeguards") to (a) insure the security and
            confidentiality of personal information; (b) protect against anticipated threats or hazards to the security or integrity
            of personal information; and (c) protect against unauthorized access or use of personal information that could
            result in substantial harm or inconvenience to any consumer. When a consumer's first name or first initial and last
            name in combination with a social security number, driver's license or Identification Card Number, or account
            number, credit or debit card number, in combination with any required security code, access code, or password
            that would permit access to an individual's financial account ("Personal Information"), is delivered to Subscriber,
            Subscriber shall implement and maintain reasonable security procedures and practices appropriate to the nature
            of the information and to protect the Personal Information from unauthorized access, destruction, use,
            modification, or disclosure. Subscriber shall notify TURSS in writing as soon as practicable but in no event later
            than forty-eight hours after which Subscriber becomes aware of any potential and/or actual misappropriation of,
            and/or any unauthorized disclosures of, any information provided to Subscriber by TURSS, including, but not
            limited to theft, loss or interception of Consumer Report Information, unauthorized use of TURSS subscriber
            codes and passwords, unauthorized entry to the facilities where TURSS data may have been accessible, or
            unauthorized release of or access to TURSS data by an employee or Agent of Subscriber. Subscriber shall fully
            cooperate with TURSS in any communications to consumers regarding the data incident and mitigating, to the
            extent practicable, any damages due to such misappropriation and/or unauthorized disclosure. Such cooperation
            shall include, but not necessarily be limited to, allowing TURSS to participate in the investigation of the cause and
            extent of such misappropriation and/or unauthorized disclosure. Such cooperation shall not relieve Subscriber of
            any liability it may have as a result of such a misappropriation and/or unauthorized disclosure. Moreover, without
            TURSS's prior consent, Subscriber shall make no public notification, including but not limited to press releases or
            consumer notifications, of the potential or actual occurrence of such misappropriation and/or unauthorized
            disclosure of any such information provided to Subscriber.</p>

        <p>5.3 <u>Authorized Requests</u>. Subscriber shall use the Services: (a) for its certified permissible purpose above to assist in
            making a residential or storage lease decision; (b) solely for Subscriber's exclusive one-time use; and (c) subject
            to the terms and conditions of this Agreement. Subscriber shall not request, obtain or use Services for any other
            purpose including, but not limited to, for the purpose of selling, leasing, renting or otherwise providing information
            obtained under this Agreement to any other party, whether alone, in conjunction with Subscriber's own data, or
            otherwise in any service which is derived from the Services. Services shall be requested by, and disclosed by
            Subscriber to only Subscriber's designated and authorized employees having a need to know and only to the
            extent necessary to enable Subscriber to use the Services in accordance with this Agreement. Subscriber shall
            ensure that such Subscriber designated and authorized employees shall not attempt to obtain any Services on
            themselves, associates, or any other person except in the exercise of their official duties.</p>

        <p>5.4 <u>Third Party Intermediaries</u>. In the event Subscriber will utilize a third party intermediary (e.g., Internet service
            provider or other network provider) for the purpose of receiving Services, Subscriber shall first enter into an
            agreement with such third party under which such third party acts solely as a network conduit for the delivery of
            the Services to Subscriber and which prohibits such third party from using, or otherwise accessing, the Services
            for any other purpose. Subscriber shall be solely liable for any actions or omissions of such third parties which
            result in a breach of this Agreement.</p>

        <p>5.5 <u>Rights to Services</u>. Subscriber shall not attempt, directly or indirectly, to reverse engineer, decompile, or
            disassemble Services or any confidential or proprietary criteria developed or used by TURSS relating to the
            Services provided under this Agreement. Except as explicitly set forth in this Agreement, the entire right, title and
            interest in and to the Services shall at all times vest exclusively in TURSS. TURSS reserves all rights not explicitly
            granted to Subscriber under this Agreement.</p>

        <p>5.6 Notwithstanding anything to the contrary in the Agreement, TURSS hereby grants a limited, non-exclusive, nontransferable
            license to the Public Record Information, and the Services derived from the Public Record
            Information, from TURSS and that the material content of the Public Record Information and the Consumer
            Reports delivered by TURSS may not be altered, edited, or otherwise changed without the prior written consent
            from TURSS.</p>

        <p>5.7 <u>Fees and Payments</u>. The Subscriber is responsible for the full payment of the Services. Upon delivery of the
            Services, Subscriber will be responsible for immediate payment, and outstanding amounts may be subject to a
            late charge of one and one-half percent (1.5%) per month (18% per year) or the maximum allowed by law,
            whichever is less. If collection efforts are required, Subscriber shall pay all costs of collection, including
            reasonable attorney's fees.</p>

            <p>5.7.1 In addition, in the event that TURSS's cost of rendering Services increases as a result of federal,
                state or local laws, ordinances or other regulatory, administrative or governmental acts, then TURSS
                may implement a surcharge subject to the following: (a) any surcharge will be applicable generally to
                TURSS's customers; and (b) any surcharge will be applied only to services pertaining to consumers
                in the geographic area so affected. A legislative surcharge is imposed on certain types of reports
                pertaining to consumers residing in the United States, and an additional surcharge is imposed on
                certain reports pertaining to only Colorado residents.</p>

        <p>5.8 <u>Term, Termination and Survival</u>. The term of this Agreement shall commence upon the agreeing to the terms of
            this Agreement and shall remain in effect until terminated by any party hereto for any reason whatsoever.</p>

            <p>5.8.1 With the exception of TURSS's obligation to provide Services under this Agreement, all provisions of
                this Agreement shall survive any such termination of this Agreement including, but not limited to, all
                restrictions on Subscriber's use of Services Information. Moreover, any such termination shall not
                relieve Subscriber of any fees or other payments due to TURSS through the date of any such
                termination nor affect any rights, duties or obligations of either party that accrue prior to the effective
                date of any such termination.</p>

        <p>5.9 <u>Limited Warranty</u>. TURSS represents and warrants that the Services will be provided in a professional and
            workmanlike manner consistent with industry standards. TURSS DOES NOT WARRANT THE SERVICES TO BE
            UNINTERRUPTED OR ERROR-FREE OR THAT THE SERVICES WILL MEET SUBSCRIBER'S
            REQUIREMENTS. THE WARRANTY SET FORTH IN THIS SECTION 4.12 IS IN LIEU OF ALL OTHER
            WARRANTIES, WHETHER STATUTORY, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
            WARRANTIES THAT MIGHT BE IMPLIED FROM A COURSE OF PERFORMANCE OR DEALING OR TRADE
            USAGE OR WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.</p>

        <p>5.10 <u>Limitation of Liability</u>. TURSS'S SOLE LIABILITY, AND SUBSCRIBER'S SOLE REMEDY, FOR
            VIOLATIONS OF THIS AGREEMENT BY TURSS OR FOR BREACH OF TURSS'S OBLIGATIONS SHALL BE
            THE CORRECTION OF ANY DEFECTIVE SERVICE OR THE REFUND OF FEES PAID FOR SAME.</p>

            <p>5.10.1 IN NO EVENT SHALL TURSS BE LIABLE FOR ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT,
                SPECIAL, OR PUNITIVE DAMAGES IN CONNECTION WITH THIS AGREEMENT, INCLUDING
                BUT NOT LIMITED TO LOSS OF GOOD WILL AND LOST PROFITS OR REVENUE, WHETHER
                OR NOT SUCH LOSS OR DAMAGE IS BASED IN CONTRACT, WARRANTY, TORT,
                NEGLIGENCE, STRICT LIABILITY, INDEMNITY, OR OTHERWISE, EVEN IF TURSS HAS BEEN
                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THESE LIMITATIONS SHALL APPLY
                NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.</p>

            <p>5.10.2 ADDITIONALLY, TURSS SHALL NOT BE LIABLE TO SUBSCRIBER FOR ANY AND ALL CLAIMS
                ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT BROUGHT MORE THAN TWO
                (2) YEARS AFTER THE CAUSE OF ACTION HAS ACCRUED.</p>

        <p>5.11 Notwithstanding anything to the contrary in the Agreement, use of Public Record Information, and the
            Services derived from the Public Record Information, from TURSS shall be subject to the following: THE PUBLIC
            RECORD INFORMATION IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. TURSS AND ITS DATA
            PROVIDERS MAKE NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, WITH RESPECT
            TO THE PUBLIC RECORD INFORMATION AND DISCLAIM ANY EXPRESS OR IMPLIED WARRANTIES WITH
            RESPECT THERETO. WITHOUT LIMITING THE FOREGOING, TURSS AND ITS DATA PROVIDERS DO NOT
            GUARANTEE OR WARRANT THE ACCURACY, TIMELINESS, COMPLETENESS, CURRENTNESS,
            MERCHANTABILITY, NON-INFRINGEMENT, OR FITNESS FOR A PARTICULAR PURPOSE OF THE PUBLIC
            RECORD INFORMATION AND SHALL NOT BE LIABLE FOR ANY LOSS OR INJURY ARISING OUT OF OR
            CAUSED IN WHOLE OR IN PART BY USE OF THE PUBLIC RECORD INFORMATION. Subscriber shall
            indemnify, defend, and hold harmless TURSS and its data providers, from and against any and all liabilities,
            damages, losses, claims, costs, fees, and expenses (including but not limited to reasonable attorney and expert
            witness fees and expenses) arising out of or related to Subscriber's use of the Public Record Information obtained
            from TURSS. Subscriber acknowledges and agrees that TURSS's data providers are a third party beneficiary of
            the provisions of this section, with right of enforcement.</p>

        <p>5.12 <u>Assignment and Subcontracting</u>. Subscriber may not assign or otherwise transfer this Agreement, in
            whole or in part without the prior written consent of TURSS. TURSS may assign or transfer this Agreement to an
            affiliate or in the event of a purchase of substantially all of TURSS's assets or in the event of a corporate form
            reorganization (e.g., LLC to C-Corporation). Moreover, TURSS shall have the unrestricted right to subcontract the
            Services to be provided to Subscriber by TURSS under this Agreement; provided however, that such
            subcontracting shall not relieve TURSS of its obligations under this Agreement. The limited warranty and
            limitation of liability provisions set forth in this Agreement shall also apply for the benefit of TURSS's licensors,
            subcontractors and agents.</p>

        <p>5.13 <u>No Waiver</u>. No failure on the part of either party to enforce any covenant, agreement, or condition of this
            Agreement shall operate as a discharge of such covenant, agreement, or condition, or render the same invalid, or
            impair the right of either party to enforce the same in the event of any subsequent breach by the other party.</p>

        <p>5.14 <u>Independent Contractors</u>. This Agreement is not intended to create or evidence any employer-employee
            arrangement, agency, partnership, joint venture, or similar relationship.</p>

        <p>5.15 <u>Severability</u>. Whenever possible, each provision of this Agreement will be interpreted in such manner as
            to be effective and valid under applicable law, but if any provision of this Agreement is held to be prohibited by or
            invalid under applicable law, such provision will be ineffective only to the extent of such prohibition or invalidity,
            without invalidating the remainder of this Agreement.</p>

        <p>5.16 <u>Force Majeure</u>. TURSS shall not be liable for any delay in performance or failure to perform under this
            Agreement if such delay or failure us caused by conditions beyond TURSS' reasonable control.</p>

        <p>5.17 <u>Audit Rights</u>. During the term of this Agreement and for a period of five (5) years thereafter, TURSS may
            audit Subscriber's policies, procedures and records which pertain to this Agreement, to ensure compliance with
            this Agreement, upon reasonable notice and during normal business hours.</p>

        <p>5.18 <u>Governing Law</u>. This Agreement shall be construed and governed by the laws of the State of Illinois,
            without reference to the choice of law principles thereof.</p>

        <p>5.19 <u>Notices</u>. Subscriber acknowledges and agrees that any notice provided by TURSS to any electronic mail
            address provided by Subscriber shall suffice for proper notice under this Agreement. Additionally, all of
            Subscriber's communications or notices required or permitted by this Agreement shall be sufficiently given for all
            purposes hereunder if given in writing and delivered to TURSS (i) personally, (ii) by United States first class mail,
            (iii) by reputable overnight delivery service, (iv) by electronic mail, or (v) by facsimile. All notices delivered in
            accordance with this Section for TURSS shall be sent to the appropriate address or number, as set forth below:
            TURSS: TransUnion Rental Screening Solutions, Attn.: Counsel for TURSS, 555 W. Adams St. Chicago, IL 60661.</p>

        <p>5.20 <u>Trademarks</u>. Both Subscriber and TURSS shall submit to the other party for written approval, prior to use,
            distribution, or disclosure, any material including, but not limited to, all advertising, promotion, or publicity in which
            any trade name, trademark, service mark, and/or logo (hereinafter collectively referred to as the "Marks") of the
            other party are used (the "Materials"). Both parties shall have the right to require, at each party's respective
            discretion and as communicated in writing, the correction or deletion of any misleading, false, or objectionable
            material from any Materials. Neither party shall remove any of the other party's Marks from any information
            materials nor reports provided to the other party and shall comply with the other party's instructions with respect
            to the use of any such Marks. Moreover, when using the other party's Marks pursuant to this Agreement, a party
            shall take all reasonable measures required to protect the other party's rights in such Marks, including, but not
            limited to, the inclusion of a prominent legend identifying such Marks as the property of the other party. In using
            each other's Marks pursuant to this Agreement, each party acknowledges and agrees that (i) the other party's
            Marks are and shall remain the sole properties of the other party, (ii) nothing in this Agreement shall confer in a
            party any right of ownership in the other party's Marks, and (iii) neither party shall contest the validity of the other
            party's Marks. Notwithstanding anything in this Agreement to the contrary, without the prior written approval of
            Subscriber, TURSS shall have the right to disclose to third parties Subscriber's marks in consumer credit reports
            containing Subscriber's account information.</p>

        <p>5.21 By signing this Agreement, Subscriber acknowledges receipt of a copy of the Federal Trade
            Commission's "Notice to Users of Consumer Reports: Obligations of Users Under the FCRA" (https://www.experian.com/connect/legal/fcra-obligations) and a copy of the
            Consumer Financial Protection Bureau's "Using Consumer Reports: What Employers Need to Know" (https://www.ftc.gov/tips-advice/business-center/guidance/using-consumer-reports-what-employers-need-know).</p>

        <p>5.22 The individual executing this Agreement has direct knowledge of all facts certified and the authority to
            both execute this Agreement on behalf of Subscriber and bind Subscriber to the terms of this Agreement.</p>

        <p>5.23 <u>TruValidate Services</u>.</p>

            <p>5.23.1 In connection with the Services, Subscriber desires to obtain TransUnion's TruValidate Service
                pursuant to the following additional terms and conditions:</p>

                <p>5.23.1.1 Subscriber and its employees shall comply with all applicable federal, state and local
                    laws, statutes, rules and regulations including, but not limited to, Section (6802) (e) of the
                    Gramm-Leach-Bliley Act ("GLB"), Title V, Subtitle A, Financial Privacy (15 U.S.C. § 6801-6809)
                    and the United States Federal Trade Commission rules promulgated thereunder, all other
                    applicable privacy laws, "do not call" laws, the Drivers Privacy Protection Act (18 U.S.C. § 2721 et
                    seq.) ("DPPA") and similar and/or associated state laws and regulations governing the use and
                    disclosure of drivers' license information, and the Telephone Consumer Protection Act (47 U.S.C.
                    § 227) ("TCPA"), Foreign Corrupt Practices Act of 1977 (15 U.S.C. §§ 78dd-1, et seq.) ("FCPA"),
                    the California Consumer Privacy Act, (California Civil Code §1798.100 et seq.) ("CCPA"), and
                    similar and/or associated state laws and regulations. Subscriber and its employees, agent(s), or
                    contractor(s) shall comply with relevant Federal and State laws regulating the collection, use, and
                    retention of biometric information.</p>

                <p>5.23.1.2 Subscriber shall comply with all terms and guidelines contained in TransUnion user
                    guides and other related documentation (together, the "Documentation") provided by
                    TransUnion in connection with the Services.</p>

                <p>5.23.1.3 TransUnion and its affiliates may use the data that Subscriber provides only in
                    connection with the Services and as may be provided by Service Agreement. TransUnion and its
                    affiliates may not use such data for any other purpose.</p>

                <p>5.23.1.4 With respect to each Subscriber request for TruValidate Services, Subscriber hereby
                    certifies that Subscriber is the user of the Services and that Subscriber and its employees will
                    request, obtain and use such Services only for the following GLB Permitted Use ("Permitted
                    Use"):</p>

                    <p>5.23.1.4.1 To use in the normal course of business to verify the accuracy of information submitted
                        by the consumer and if it is not correct, to obtain the correct information, but only to
                        protect against or prevent actual fraud, unauthorized transactions, claims or other liability.</p>

                <p>5.23.1.5 Subscriber shall not request, obtain or use Services for marketing purposes nor for any
                    purpose except as expressly provided for herein. Moreover, Subscriber shall not take any
                    adverse action, which is based in whole or in part on the TruValidate Services, against any
                    consumer. For the purposes of this Service Agreement, the terms "adverse action" and
                    "consumer" shall have the same respective meaning as those terms are defined in the FCRA.</p>

                <p>5.23.1.6 In no event shall Subscriber use any of the TruValidate Services, in whole or in part, as a
                    factor in establishing an individual's creditworthiness or eligibility for (i) credit or insurance, or (ii)
                    employment, nor for any other purpose under the Fair Credit Reporting Act (15 U.S.C. §1681 et
                    seq.) ("FCRA").</p>

                <p>5.23.1.7 To the extent that any TruValidate Service contains, in whole or in part, Consumer
                    Reports as defined in the FCRA, Subscriber certifies that it will request and use these Services
                    solely for one of the permissible purposes certified in the Service Agreement. Subscriber may
                    request and use Account Verification only subject to the written authorization of the subject
                    consumer.</p>

            <p>5.23.2 TransUnion hereby provides Subscriber a limited, nonexclusive, non-transferable, non-sub licensable,
                revocable license to use the TruValidate Services (together with all content therein, and all
                applications, programs, license keys, patches, updates, or upgrades provided by TransUnion, and
                any improvements, modifications, enhancements, fixes and revised versions of any of the foregoing,
                and any derivative works of any of the foregoing, and any combination of the foregoing, collectively
                defined herein as the "Software", during the term of the applicable Service Agreements, solely for the
                purposes described herein and in the Documentation. As between the parties, TransUnion retains all
                right, title, and interest in and to the Software and Service and all copies and derivative works thereof,
                which rights include, but are not limited to, patent, copyright, trademark, trade secret, and all other
                intellectual property rights. TransUnion reserves all rights not expressly granted herein and, except as
                expressly granted in the Service Agreements or this Addendum, no right or license is granted to
                Subscriber hereunder, express or implied or by way of estoppel, to any technology or intellectual
                property rights.</p>

            <p>5.23.3 Subscriber shall not, directly or indirectly, authorize any person or entity to: (i) sell, rent, lease,
                distribute, redistribute or transfer the TruValidate Services or any software development kit, as
                applicable, or any rights in any of the Software, or use the TruValidate Services in a hosted or
                managed services environment; (ii) reverse engineer, decompile, disassemble, re-engineer or
                otherwise create or attempt to create or permit, allow, or assist others to create or derive the source
                code of the TruValidate Services, or its structural framework; (iii) modify or create derivative works of
                the Software; (iv) use the TruValidate Services in whole or in part for any purpose except as
                expressly provided under this Agreement or in the Documentation; (vi) remove any proprietary notice,
                labels, or marks on or in Software; or (vii) disable or circumvent any access control or related device,
                process or procedure established with respect to the Software. Subscriber may not use the
                TruValidate Services for illegal or unlawful or malicious activities.</p>

            <p>5.23.4 Subscriber agrees that any performance agreements, uptime commitments, performance metrics,
                and service level commitments contained in the Agreement, any Service Agreement, or statement of
                work, shall not apply to TruValidate Services.</p>

        <p>Entire Agreement. THIS AGREEMENT INCLUDING, WITHOUT LIMITATION, ALL EXHIBITS AND ATTACHMENTS
            HERETO, CONSTITUTES THE ENTIRE AGREEMENT BETWEEN TURSS AND SUBSCRIBER AND SUPERSEDES ALL
            PREVIOUS AGREEMENTS AND UNDERSTANDINGS, WHETHER ORAL OR WRITTEN, EXPRESS OR IMPLIED,
            SOLELY WITH RESPECT TO THE SUBJECT MATTER OF THIS AGREEMENT. THIS AGREEMENT MAY NOT BE
            ALTERED, AMENDED, OR MODIFIED EXCEPT BY WRITTEN INSTRUMENT SIGNED BY THE DULY AUTHORIZED
            REPRESENTATIVES OF BOTH PARTIES.</p>

        <p>All users of consumer reports must comply with all applicable regulations. Information about applicable regulations currently
            in effect can be found at the Consumer Financial Protection Bureau's website, www.consumerfinance.gov/learnmore.</p>
    </div>
);



// WEBPACK FOOTER //
// ./src/util/FormConstants.js